import React, { useEffect,useState,useRef } from 'react';
import UEditor from '../../components/UEditor';
import {Form,Button,Input,message,Select,Radio,Divider,Modal,Progress,Cascader,Space,DatePicker,Checkbox,List,Image,ConfigProvider } from 'antd'
import Icon,{UploadOutlined,DeleteOutlined  } from '@ant-design/icons';
import UploadFile from '../../components/UploadFile';
import {getApiData} from "../../../request/api";
import checkLogin from '../../../request/checkLogin.js'

import CryptoJs from 'crypto-js';
import axios from 'axios';
import './index.css'
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';
// import { fromJS } from 'immutable';
moment.locale('zh-cn')
const { RangePicker } = DatePicker;

const {Item} = Form
const { Option } = Select;
const screenHeight = document.body.clientHeight;
const screenWidth = document.body.clientWidth;


function getDateStr(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
    var year = dd.getFullYear();
    var mon = dd.getMonth() + 1; //获取当前月份的日期
    var day = dd.getDate();
    return year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day);
  }
  

const PublishArticle = (props) => {
    const {showAddtc, modalinfo,levellist,rewardList,statuslist, rowInfo, closeAddtc, refreshList} = props;
    // console.log('showAddtc, modalinfo levellist - ', showAddtc, modalinfo, levellist)
    const [form] = Form.useForm();
    const ueRef = useRef(null)
    const ueRef2 = useRef(null)

    var levelOptions = [];
    for(let item of levellist){
        if(item.value)
            levelOptions.push(item);
    }
    // console.log('levellist ---------- ', levellist);
    // console.log('levelOptions ---------- ', levelOptions);

    var rewardOptions = [];
    for(let item of rewardList){
        if(item.value)
        rewardOptions.push(item);
    }

    var statusOptions = [];
    for(let item of statuslist){
      if(item.value != 3)
        statusOptions.push(item);
    }
    console.log('statusOptions ---------- ', statusOptions);

    const [percent, setpercent] = useState({});
    const [percentShow,setPercentShow] = useState({});
    const [imageUrl,setImageUrl] = useState({});
    // const [imageShow,setImageShow] = useState({});
    const [attpercent, setAttpercent] = useState(0);
    const [attpercentShow,setAttpercentShow] = useState(false);
    const [attachmentList,setAttachmentList] = useState([]);
    const [catOptions, setCatOptions] = useState([]);
    const [template, setTemplate] = useState({base:[], offer:[]});
    // const [allEditor, setAllEditor] = useState({});
    const [loading,setLoading] = useState(false);
    const [selectedStatus,setSelectedStatus] = useState("0");

    useEffect(() => {
        if(showAddtc){
            window.UE._CUR_PLATFORM = "A";
            setSelectedStatus(rowInfo.status);

            var pid = "";
            if(modalinfo.tid){
                setTemplate(modalinfo.template);
                pid = modalinfo.catid;
            }
            else {
              for(let key in rowInfo){
                if(key == 'judgerecord'){
                  for(let k in rowInfo.judgerecord)
                    form.setFieldValue(k, rowInfo.judgerecord[k]);
                }
                else
                  form.setFieldValue(key, rowInfo[key]);
              }
              if(rowInfo.detail){
                  setTemplate(rowInfo.detail);
                  try {
                    // var editor = [];
                    for(let item of rowInfo.detail.base){
                        // console.log('item------------------',item)
                        var myvalue = item.myvalue;
                        if(!myvalue)
                        continue;
                        if(item.type == 'select_category')
                            pid = item.myvalue[0];
                        else if(item.type == 'range')
                            myvalue = [moment(item.myvalue[0]), moment(item.myvalue[1])];
                        else if(item.type == 'upload'){
                            var imgt = imageUrl;
                            imgt[item.name] = myvalue;
                            setImageUrl(imgt);
                        }
                        //   else if(item.type == 'editor'){
                        //     editor[item.name] = myvalue;
                        //     setTimeout(() => {
                        //         document.getElementById(item.name).contentWindow.setContent(item.myvalue);
                        //     }, 500);
                        //   }
                          form.setFieldValue(item.name, myvalue);
                      }
                      for(let item of rowInfo.detail.offer){
                        var myvalue = item.myvalue;
                        if(!myvalue)
                            continue;
                        if(item.type == 'select_category')
                            pid = item.myvalue[0];
                        else if(item.type == 'range')
                            myvalue = [moment(item.myvalue[0]), moment(item.myvalue[1])];
                        else if(item.type == 'upload'){
                            var imgt = imageUrl;
                            imgt[item.name] = myvalue;
                            setImageUrl(imgt);
                        }
                      //   if(item.type == 'editor'){
                        //     // await waitTime(100);
                        //     editor[item.name] = item.myvalue;
                        //     setTimeout(() => {
                        //         document.getElementById(item.name).contentWindow.setContent(item.myvalue);
                        //     }, 500);
                        //   }
                        form.setFieldValue(item.name, myvalue);
                      }
                    //   setAllEditor(editor);
                      var list = [];
                      for(let type in rowInfo.detail.attach){
                          for(let url of rowInfo.detail.attach[type])
                              list.push({type:type, url:url});
                      }
                      setAttachmentList(list);
                  }catch(error){
                      console.log('catch-error1 ---------- ', error)
                  }
              }
            }

            if(pid && catOptions.length == 0){
                getCatOptions(pid);
            }

        } else {
          setpercent({});
          setPercentShow({});
          setImageUrl({});
          setAttpercent(0);
          setAttpercentShow(false);
          setAttachmentList([]);
          setCatOptions([]);
          setTemplate({base:[], offer:[]});
        //   setAllEditor({});
          form?.resetFields();
          setSelectedStatus("0");
        }
      }, [showAddtc, rowInfo]);
  
    //获取参赛组别
    const getCatOptions = (pid) => {
        try {
            getApiData('A', 'A_catelogList', {pid:pid}).then((res) => {
            console.log('A_catelogList-res-----------------', res);
            var flag = checkLogin('A', res.data)
            if (flag) {
                setCatOptions([res.data.d.list]);
            }
            });
        } catch (error) {
            console.log('catch-error2 ---------- ', error)
            // return false;
        }
        
    };

    const tailLayout = {
        wrapperCol: { offset: 10, span: 8 },
    };
    const [radioVal, setRadioVal] = useState(1)
    //编辑器的宽度
    const [config] = useState({
        initialFrameWidth: '100%',
        initialFrameHeight: 400
    })
    //编辑器的默认值
    const [initData] = useState('')
    //富文本失焦就触发setContent函数设置表单的content内容
    const setContent = async (name, e)=>{
        var value = {};
        value[name] = e;
        form.setFieldsValue(value);
        // setTimeout(() => {
        //     for(name in allEditor)
        //         document.getElementById(name).contentWindow.setContent(allEditor[name]);
            
        // }, 2000);
    }
    const [initData2] = useState('')
    //富文本失焦就触发setContent函数设置表单的content内容
    const setContent2 = (e)=>{
        form.setFieldsValue({
            content2: ueRef2.current.getUEContent()
        })
    }

     //提交修改
    const onFinish = async (values) => {
        console.log(values);
        if(!values.name || !values.category){
            message.warn("请输入作品名称和参赛组别");
            return;
        }
        // var record = {
        //   level1: values.level1, 
        //   level2: values.level2, 
        //   level3: values.level3
        // };
        var status = values.status;
        // delete values.level1;
        // delete values.level2;
        // delete values.level3;
        delete values.account;
        delete values.symbol;
        delete values.ctime;
        delete values.follow;
        delete values.status;

        var attch = {};
        for(let item of attachmentList){
            if(attch[item.type] == undefined)
                attch[item.type] = [];
            attch[item.type].push(item.url);
        };
        try {
            var p = {
                cid:rowInfo.id,
                templateid : rowInfo.templateid,
                name: values.name,
                categoryid: values.category[values.category.length-1],
                content: values,
                level:values.level,
                result:values.result,
                status:status,
                refusereason:values.refusereason,
                attach: {
                    PDF: attch.PDF ? attch.PDF : [],
                    VIDEO: attch.VIDEO ? attch.VIDEO : [],
                    PIC: attch.PIC ? attch.PIC : []
                },
            };
            console.log(p)
            setLoading(true);
            await getApiData('A', "A_editCase", p).then((res) => {
                setLoading(false);
                console.log('A_editCase-res-----------------', res);
                var flag = checkLogin('A', res.data)
                if (flag) {
                    message.success("操作成功");
                    closeAddtc();
                    refreshList();
                }
            });
            } catch (error) {
              console.log('catch-error ---- ', error);
              message.error("网络异常");
                setLoading(false);
                return false;
            }
        // message.error('发布未成功')
    };
    
        
    const showItems=(key)=>{
        if(!template)
            return;
        if(!template.hasOwnProperty(key))
            return;

        return template[key].map(item=>{
            // console.log('111111111111111111111111111111 - ', item)
            var desc = '';
            if(item.desc)
                desc = (<div style={{color:'#d92a05',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"110%"}}>*{item.desc}</div>);
            if(item.type == 'upload')
                return (
                    <Item name={item.name}  label={item.title} >
                        <UploadFile 
                            from = {"A"}
                            upButton = {<Button icon={<UploadOutlined />} type="primary" shape='round'  style={{color:"white",backgroundColor: "rgb(231,76,60)",borderColor: "rgb(231,76,60)"}} >上传</Button>}
                            uploadFileType = {".png, .jpg, .jpeg, .gif"}
                            uploadFileSize = {5*1024*1024}
                            setpercent = {(v)=>{
                                console.log('percent - ', v)
                                setpercent({...percent, [item.name]:v});
                            }}
                            setPercentShow = {(v)=>{
                                console.log('percentShow - ', v)
                                setPercentShow({...percentShow, [item.name]:v});
                            }}
                            setFileUrl = {(v)=>{
                                console.log('imageUrl - ', v)
                                setImageUrl({...imageUrl, [item.name]:v});
                                form.setFieldValue(item.name, v);
                            }}
                            show = {showAddtc}
                            upname = {item.name}
                        />
                        <Progress percent={percent[item.name]} style={{width:'80%',top:-30,left:100,display:percentShow[item.name]?'block':'none'}}/>
                        {/* <img src={imageUrl.logo} height={100} style={{display: imageShow.logo==true?'block':'none'}} /> */}
                        {imageUrl[item.name] ? (
                            <div style={{height:100, width:"fit-content",textAlign:"center", marginTop:5}}>
                            <Image
                            height={80}
                            src={imageUrl[item.name]}
                            />
                            <br />
                            <Button danger type='primary' 
                            style={{width:"100%", height:18, borderRadius:3,marginBottom:5}} 
                            icon={<DeleteOutlined style={{fontSize:10}} />} 
                            onClick={()=>{
                                setpercent({...percent, [item.name]:0});
                                setPercentShow({...percentShow, [item.name]:false});
                                setImageUrl({...imageUrl, [item.name]:""});
                                form.setFieldValue(item.name, "");
                            }} />
                            </div>
                        ) : "" }
                        {desc}
                    </Item>
                )
            else if(item.type == 'text'){
                let rules = [{required: true, message: '请输入'+item.title}];
                if(item.selectdata != undefined){
                    rules.push({max:parseInt(item.selectdata[0]),message: item.title+'最多'+item.selectdata[0]+'字'})
                }
                return (
                    <Item name={item.name}  label={item.title} extra={desc} rules={rules} >
                        <Input allowClear/>
                    </Item>
                )
            }
            else if(item.type == 'select_category'){
                return (
                    <Item name={item.name}  label={item.title} extra={desc} rules={[{required: true, message: '请选择'+item.title}]}>
                        <Cascader options={catOptions} allowClear={false} placeholder="请选择"
                        fieldNames={{
                            label: 'name',
                            value: 'cid',
                            children: 'children',
                            }}
                        defaultValue={[]} />
                    </Item>
                )
            }
            else if(item.type == 'range')
                return (
                    <Item name={item.name}  label={item.title} extra={desc} rules={[{required: true, message: '请选择'+item.title}]}>
                        <RangePicker  format={"YYYY-MM-DD"}
                         allowClear={false}  locale={locale}
                            // defaultValue={[moment(getDateStr(0)), moment(getDateStr(0))]}
                            // ranges={{
                            //     '今 日': [moment(), moment()],
                            //     '昨 日': [moment(getDateStr(-1)), moment(getDateStr(-1))],
                            //     '7 天': [moment(getDateStr(-7)), moment(getDateStr(-1))],
                            //     '14 天': [moment(getDateStr(-14)), moment(getDateStr(-1))],
                            //     '30 天':[moment(getDateStr(-30)), moment(getDateStr(-1))]
                            // }}
                            // onChange={this.getChangeTime}  
                            />
                    </Item>
                )
            else if(item.type == 'select_custom')
                return (
                    <Item name={item.name}  label={item.title} extra={desc} rules={[{required: true, message: '请选择'+item.title}]}>
                        <Select
                            placeholder="请选择"
                            // onChange={onGenderChange}
                            // defaultValue={""}
                            // allowClear
                            // style={{width:"50%"}}
                        >
                            { item.selectdata ? item.selectdata.map(one=>{ return (<Option value={one}>{one}</Option>)}) : []}
                            {/* { Object.keys(item.selectdata).map(index=>{ return (<Option value={index}>{item.selectdata[index]}</Option>)})} */}
                        </Select>
                    </Item>
                )
            else if(item.type == 'editor'){
                return (
                    <Item name={item.name}  label={item.title} extra={desc} rules={[{required: true, message: '请输入'+item.title}]}>
                        <UEditor id={item.name} ref={ueRef} config={config} show={showAddtc} initData={rowInfo.detail?item.myvalue:""} setContent={(e)=>setContent(item.name, e)}></UEditor>
                    </Item>
                )
            }
        })
    }
  

    const onChangeGroup = (value) => {
        console.log(value);
      };

    const attachmentListAdd = (type, value) => {
        console.log(type, value);
        var list = attachmentList;
        list.push({type:type, url:value})
        setAttachmentList(list);
        setAttpercentShow(false);
        setAttpercent(0)
    };

    const attachmentListDel = (value) => {
        console.log(value);
        var list = attachmentList;
        list = list.filter(item => item != value);
        setAttachmentList(list);
    };

    const CustomEmptyList = () => (
        // 这里面就是我们自己定义的空状态
        <span></span>
    )

    const  Attshowimage = (item) => {
        // var  ext = item.substring(item.lastIndexOf('.') + 1, item.lenght);
        // console.log('item----------------------',item);
        if(item.type == 'PDF')
            return ( <img src={[require("../../../img/pdf.png")]} alt="" width={80}  onClick={()=>{view(item.url,"pdf")}} />);
        else if(item.type == 'VIDEO')
            return ( <img src={[require("../../../img/mp4.png")]} alt="" width={80}  onClick={()=>{view(item.url,"video")}} />);
            // return ( <img src={[require("../../../img/mp4.png")]} alt="" width={80} onClick={()=>{setCurVideoUrl(item.url);setShowModal(true);}}  />);
        else
            return (
                <Image
                    // width={200}
                    height={80}
                    src={item.url}
                    preview={false}
                    onClick={()=>{view(item.url,"pic")}}
                    // fallback="data:image/png;base64,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"
                />
        )
    }
  
    // 打开附件PDF或图片在线预览
    const view = async(url, type)=>{
        try {
            return await getApiData('A', 'A_viewAttach', {"url":url,"type":type}).then((res) => {
              console.log('A_viewAttach-res-----------------', res);
              var flag = checkLogin('A', res.data)
              if (flag) {
                window.open(res.data.d.url);
              }
            });
          } catch (error) {
            
            return false;
          }
      }
    
    return (
        console.log('imgUrl----------------', imageUrl),
        console.log('attachmentList----------------', attachmentList),
      <Modal 
        key="basicinfo"
        title={rowInfo.id ? '编辑' :'添加'}
        open={showAddtc}
        width={screenWidth*0.9}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeAddtc}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeAddtc}>
        <div className="PublishArticle-wrap" style={{marginTop:0}} >
            <Form 
                style={{width:'90%', paddingTop:0}} 
                autoComplete="off" 
                form={form} 
                onFinish={onFinish}
                labelAlign={'left'}
                labelCol={{span:4}}
            >
                <div className="add_title" style={{marginTop:0}}>基本信息</div>
                <Divider className='add_divide' />
                <Form.Item
                  label="用户ID"
                  name="account"
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="作品编号"
                  name="symbol"
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="添加时间"
                  name="ctime"
                >
                  <Input disabled />
                </Form.Item>
                {showItems("base")}

                <div className="add_title">作品描述</div>
                <Divider className='add_divide' />
                {showItems("offer")}

                <div className="add_title">上传附件</div>
                <Divider className='add_divide' />
                <div className='divfj'>
                    <div className='sbutt'>上传附件</div>
                    <div className="divfj-x">
                        <div style={{borderLeft:0, position:"relative"}} className="divfj-xy">
                            <div style={{width:"100%",textAlign:"center"}}>
                                {
                                    attpercentShow ? <img src={[require("../../../img/pdf.jpg")]} alt="" className='divfj-xy-1 not-allowed' /> : 
                                    <UploadFile 
                                        from = {"A"}
                                        upButton = {<img src={[require("../../../img/pdf.jpg")]} alt="" className='divfj-xy-1' />}
                                        uploadFileType = {".pdf"}
                                        uploadFileSize = {50*1024*1024}
                                        setpercent = {setAttpercent}
                                        setPercentShow = {setAttpercentShow}
                                        setFileUrl = {(url)=>attachmentListAdd("PDF", url)}
                                        show = {showAddtc}
                                    />
                                }
                            </div>
                            <div className="divfj-xy-2">PDF</div>
                            <div className="divfj-xy-3">pdf格式</div>
                            <div className="divfj-xy-4">文件大小限制: 50MB</div>
                        </div>
                        <div className="divfj-xy" style={{position: "relative"}}>
                            <div style={{width:"100%",textAlign:"center"}}>
                                {
                                    attpercentShow ? <img src={[require("../../../img/video.jpg")]} alt="" className='divfj-xy-1 not-allowed' /> : 
                                    <UploadFile 
                                        from = {"A"}
                                        upButton = {<div style={{textAlign:"center"}}><img src={[require("../../../img/video.jpg")]} alt="" className='divfj-xy-1' /></div>}
                                        uploadFileType = {".mp4"}
                                        uploadFileSize = {500*1024*1024}
                                        setpercent = {setAttpercent}
                                        setPercentShow = {setAttpercentShow}
                                        setFileUrl = {(url)=>attachmentListAdd("VIDEO", url)}
                                        show = {showAddtc}
                                    />
                                }
                            </div>
                            <div className="divfj-xy-2">视频</div>
                            <div className="divfj-xy-3">mp4格式</div>
                            <div className="divfj-xy-4">文件大小限制: 500MB</div>
                            <div className="divfj-xy-4">推荐尺寸：800PX*450PX</div>
                        </div>
                        <div className="divfj-xy" style={{position: "relative"}}>
                            <div style={{width:"100%",textAlign:"center"}}>
                                {
                                    attpercentShow ? <img src={[require("../../../img/picture.jpg")]} alt="" className='divfj-xy-1 not-allowed' /> : 
                                    <UploadFile 
                                        from = {"A"}
                                        upButton = {<img src={[require("../../../img/picture.jpg")]} alt="" className='divfj-xy-1' />}
                                        uploadFileType = {".png, .jpg, .jpeg, .gif"}
                                        uploadFileSize = {5*1024*1024}
                                        setpercent = {setAttpercent}
                                        setPercentShow = {setAttpercentShow}
                                        setFileUrl = {(url)=>attachmentListAdd("PIC", url)}
                                        show = {showAddtc}
                                    />
                                }
                            </div>
                            <div className="divfj-xy-2">图片</div>
                            <div className="divfj-xy-3">jpg.jpeg.gif.png</div>
                            <div className="divfj-xy-4">文件大小限制: 5MB</div>
                            <div className="divfj-xy-4">推荐尺寸：800PX*450PX</div>
                        </div>
                    </div>
                </div>
                <Progress percent={attpercent} strokeWidth={12} style={{width:'50%',top:-130,left:"27%",display:attpercentShow?'block':'none'}}/>
                <ConfigProvider renderEmpty={CustomEmptyList}>
                <List
                    grid={{
                        gutter: 10,
                    }}
                    bordered={false}
                    split={false}
                    dataSource={attachmentList}
                    style={{marginTop:10}}
                    renderItem={(item) => (
                        // console.log('list-item ---------------', item),
                        <List.Item>
                            {/* <a href={item.url} data-url={item.url} target="_blank" className="thumbnail"> */}
                                {Attshowimage(item)}
                            {/* </a> */}
                            <Button danger type='primary' style={{width:"100%", height:20, borderRadius:3}} icon={<DeleteOutlined style={{fontSize:10}} />} onClick={()=>attachmentListDel(item)} />
                        </List.Item>
                    )}
                />

              <div className="add_title">评审情况</div>
              <Divider className='add_divide' />
              <Form.Item
                label="评选阶段"
                name="level"
              >
                <Radio.Group style={{width:"80%"}} options={levelOptions} />
              </Form.Item>
              <Form.Item
                label="获奖结果"
                name="result"
              >
                <Radio.Group style={{width:"80%"}} options={rewardOptions} />
                  {/* <Space size={10}>
                  <Radio value={"0"}>不通过</Radio>
                  <Radio value={"1"}>通过</Radio>
                  </Space>
                </Radio.Group> */}
              </Form.Item>
              <Form.Item
                  label="跟进人"
                  name="follow"
              >
              <Input disabled />
              </Form.Item>
              <Form.Item
                label="审核状态"
                name="status"
              >
                <Radio.Group style={{width:"80%"}} options={statusOptions} onChange={(e)=>{setSelectedStatus(e.target.value)}} />
                  {/* <Space size={10}>
                  <Radio value={"0"}>不通过</Radio>
                  <Radio value={"1"}>通过</Radio>
                  </Space>
                </Radio.Group> */}
              </Form.Item>
              <Form.Item
                  label="拒绝原因"
                  name="refusereason"
                  style={{display:selectedStatus==2?"block":"none"}}
                  rules={[{required: selectedStatus==2?true:false, message: '请输入审核意见'}]}
              >
              <Input />
              </Form.Item>
            </ConfigProvider>

            </Form>
        </div>
      </Modal>
    )
}

export default PublishArticle